module.exports = __webpack_public_path__ + "static/media/login-3.05371463.jpg";